

module.exports = function($) {

    return {
        init: init
    };

    function init() {
        launchNav();
        launchSubNav();
    }

    function launchNav() {
        var launchElement = $('[data-toggle-nav]');
        var nav = $('[data-nav]');

        launchElement.on('click', function(event) {
            var $this = $(this);

            if ( $('body').hasClass('nav-child-visible') ) {
                // close open submenus
                $('.menu-item-has-children').removeClass('active');
                $('body').removeClass('nav-child-visible');
            } else {
                // toggle top level
                $('body').toggleClass('freeze-body nav-menu-visible');
                nav.toggleClass('active');
            }

            // if it's an anchor prevent default
            if ( $this.attr('href') ) {
                event.preventDefault();
            }
        });
    }

    function launchSubNav() {
        var launchElement = $('.menu-item-has-children > a');

        launchElement.on('click', function(event) {
            var $this = $(this);

            $this.parent('li').toggleClass('active');
            $('body').addClass('nav-child-visible');

            // if it's an anchor prevent default
            if ( $this.attr('href') ) {
                event.preventDefault();
            }
        });
    }
};
